import { OktaScopeConfig } from './okta-auth-api.types';
import { ReactComponent as LiveFeedIcon } from '../assets/icons/nav-menu-link-live-feed-full.svg';
import { ReactComponent as WorkZonesIcon } from '../assets/icons/nav-menu-link-czdm-full.svg';
import { ReactComponent as RoadInventoryIcon } from '../assets/icons/nav-menu-link-ridm-full.svg';
import { ReactComponent as VirtualCamIcon } from '../assets/icons/nav-menu-link-vcctv-full.svg';

export const OktaMinimalPasswordLength: number = 4;

export enum OktaAuthnErrorCodes {
  AuthenticationFailed = 'E0000004',
  AccessDenied = 'access_denied',
}

export enum OktaScopes {
  VirtualCamera = 'VirtualCamera',
  LiveFeed = 'LiveFeed',
  WorkZones = 'WorkZones',
  RoadInventory = 'RoadInventory',
}

export enum OktaGroups {
  WorkZones = 'workzones-product-api',
  LiveFeed = 'livefeed-product-api',
  RoadInventory = 'roadinventory-product-api',
  VirtualCam = 'virtualcam-product-api',
  NexarPlatform = 'nexar-platform-api',
}

export const DisplayedOktaScopes: OktaScopes[] = [
  OktaScopes.LiveFeed,
  OktaScopes.WorkZones,
  OktaScopes.RoadInventory,
  OktaScopes.VirtualCamera,
]

export const OktaScopesConfig: { [oktaScope: string]: OktaScopeConfig } = {
  VirtualCamera: {
    title: 'Virtual Camera',
    value: 'frame%3Aget%20image%3Aget%20',
    group: OktaGroups.VirtualCam,
    icon: VirtualCamIcon,
  },
  LiveFeed: {
    title: 'Live Feed',
    value: 'detection%3Afind%20detection%3Aget%20image%3Aget%20',
    group: OktaGroups.LiveFeed,
    icon: LiveFeedIcon,
  },
  WorkZones: {
    title: 'Work Zones',
    value: 'detection%3Afind%20detection%3Aget%20image%3Aget%20',
    group: OktaGroups.WorkZones,
    icon: WorkZonesIcon,
  },
  RoadInventory: {
    title: 'Road Inventory',
    value: 'detection%3Afind%20detection%3Aget%20image%3Aget%20',
    group: OktaGroups.RoadInventory,
    icon: RoadInventoryIcon,
  },
};
